import React, { useEffect, useState } from "react";

import Loader from "../components/Loader";

import { connect } from "react-redux";

import {
  getFeaturedNewProducts,
  getNewDefaultProducts,
} from "../redux/actions/products";
import { getNewProductsPromotion } from "../redux/actions/promotions";
import { setSubRoute } from "../redux/actions/navigation";

import FeaturedProductForm from "../components/NewProductsContent/FeaturedProductForm";
import FeaturedPromotionForm from "../components/NewProductsContent/FeaturedPromotionForm";
import DefaultProductForm from "../components/NewProductsContent/DefaultProductForm";
import ListPageHeader from "../components/Shared/ListPageHeader";
import PageTabs from "../components/Shared/PageTabs";

import styles from '../styles/pages/FeaturedContentPages/NewProductsPageContent.module.css'



const NewProductsPageContent = ({
  getFeaturedNewProducts,
  getNewProductsPromotion,
  getNewDefaultProducts,
  setSubRoute,
  product: { isLoading },
  navigation: { subRoute },

}) => {

  useEffect(() => {
    if (!subRoute || !subRoute.startsWith('new-product')) {
      setSubRoute('new-product-featured-product')
    }
  }, [subRoute])

  useEffect(() => {
    getFeaturedNewProducts();
    getNewProductsPromotion();
    getNewDefaultProducts();
  }, [getFeaturedNewProducts, getNewProductsPromotion, getNewDefaultProducts]);

  const tabs = [
    {name: 'Featured Products', subRoute: 'new-product-featured-product'},
    {name: 'Default Featured Products', subRoute: 'new-product-default-featured-product'},
    // {name: 'Promotion Featured Products', subRoute: 'new-product-promotion-featured-product'},
  ]

  const handleChangeTab = (tab) => {
    setSubRoute(tab)
  }

  return isLoading ? (
    <Loader />
  ) : (
    <div>
       <ListPageHeader
          title={' New Product Page Featured Content'}
          description={'Browse and manage all featured content for the Dental Product Shopper new product page.  This page lets you add, edit, or remove featured content.'}
         
          subComponent={
            <PageTabs 
              tabs={tabs} 
              selectedTab={subRoute} 
              handleChangeTab={handleChangeTab} 
              desktopStyles={styles.page_tab_desktop}
              mobileStyles={styles.mobile_tab_desktop}
              mobileDropdownLabel={'Select Section'}
              />
          }
          
      />
     
      {subRoute === 'new-product-featured-product' ? (
        <FeaturedProductForm />
      ) : subRoute === 'new-product-default-featured-product' ? (
        <DefaultProductForm />
      // ) : subRoute === 'new-product-promotion-featured-product' ? (
      //   <FeaturedPromotionForm />
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => ({
  product: state.product,
  navigation: state.navigation,
});

export default connect(mapStateToProps, {
  getFeaturedNewProducts,
  getNewProductsPromotion,
  getNewDefaultProducts,
  setSubRoute,
})(NewProductsPageContent);
